/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Timeslotid2Inputs */

const en__field_timeslotid2 = /** @type {(inputs: _Field_Timeslotid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeslot ID`)
};

const de__field_timeslotid2 = /** @type {(inputs: _Field_Timeslotid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitslot ID`)
};

/**
* | output |
* | --- |
* | "Timeslot ID" |
*
* @param {_Field_Timeslotid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_timeslotid2 = /** @type {((inputs?: _Field_Timeslotid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Timeslotid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_timeslotid2(inputs)
	return de__field_timeslotid2(inputs)
});
export { _field_timeslotid2 as "_field_timeslotID" }